module.exports = __webpack_public_path__ + "static/bookshelf-dc571e2c5a05de9051c327fec0ab881e.jpeg";